import ComponentElement from 'components/component-element';
import Select from 'components/select';

function KurortDistanceFilter($element, options) {
    ComponentElement.call(this, $element, options);

    this.name = this.options.name;
    this.title = this.options.title;
    this.filterTitle = this.options.filterTitle;
    this.value = this.options.value;

    this.$select = this.$element.querySelector('.Select[data-name]');
    this.select = new Select(this.$select, {
        on: {
            change: this._onSelectChangeEvent.bind(this),
            open: this._onSelectOpenEvent.bind(this),
            close: this._onSelectCloseEvent.bind(this),
        },
    });

    if (this.value) {
        this.setValue(this.value, false);
    }
}

// цепочка прототипов
KurortDistanceFilter.prototype = Object.create(ComponentElement.prototype, {
    constructor: {
        value: KurortDistanceFilter,
        enumerable: false,
        writable: true,
    }
});

KurortDistanceFilter.prototype.getSelectedValueTitle = function () {
    return this.select.getSelectedItem().textContent;
}

KurortDistanceFilter.prototype.setValue = function (value, event = true) {
    this.select.setValue(value, event);
}

KurortDistanceFilter.prototype.recalc = function (items) {
    // скрываем фильтр, если нет данных
    if (!items || !Array.isArray(items) || !items.length) {
        this.$element.style.display = 'none';

        return;
    }

    this.select.setItems(items);

    items.some(item => {
        if (item.selected) {
            this.select.setValue(item.value);

            return true;
        }

        return false;
    });

    // показываем сам фильтр
    if (this.$element) {
        this.$element.style.display = '';
    }
}

KurortDistanceFilter.prototype.reset = function () {
    this.select.reset();
}

KurortDistanceFilter.prototype.isInit = function () {
    return !!this.select.getSelectedIndex();
}

KurortDistanceFilter.prototype._onSelectChangeEvent = function () {
    this.emit('change', ...arguments);
}

KurortDistanceFilter.prototype._onSelectOpenEvent = function () {
    this.emit('open', ...arguments);
}

KurortDistanceFilter.prototype._onSelectCloseEvent = function () {
    this.emit('close', ...arguments);
}

export default KurortDistanceFilter;
